import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
/** @jsxFrag */

import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl-next';
import { css, jsx } from '@emotion/react';
import TRELLO_ERROR_SRC from '../../assets/trello-error';
import UNVERIFIED_ERROR_SRC from '../../assets/unverified-error';
import { NAVIGATION_CHANNEL, OPERATIONAL_EVENT_TYPE, UI_EVENT_TYPE, withAnalyticsEvents } from '../../common/utils/analytics';
import { getLoginUrl } from '../../common/utils/environment';
import { errorToReason } from '../../common/utils/error-to-reason';
import messages from '../../common/utils/messages';
import { Product } from '../../types';
import { FormattedMessage } from 'react-intl-next';
import StyledComponentsButton from '../primitives/styled-components-button';
import { SwitcherLoadError } from '../../common/utils/errors/switcher-load-error';
import { FETCH_ERROR_NAME } from '../../common/utils/errors/fetch-error';
var TRIGGER_SUBJECT = 'errorBoundary';
var ACTION_SUBJECT = 'rendered';
// This image is also used as the generic error message in Notifications

var robotsImgStyles = css({
  height: 200
});
var trelloErrorImgStyles = css({
  width: 140,
  height: 88
});
var unverifiedUserImageStyles = css({
  height: 150
});
var errorContentStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column'
});
var errorHeadingStyles = css({
  maxWidth: 240,
  marginTop: "var(--ds-space-400, 32px)"
});
var errorMessageStyles = css({
  maxWidth: 240,
  marginTop: "var(--ds-space-300, 24px)"
});
var loginButtonStyles = css({
  marginTop: "var(--ds-space-300, 24px)"
});
var errorBoundaryBoxStyles = css({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  textAlign: 'center'
});
var errorBoundaryBoxDrawerStyles = css({
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  paddingTop: 128,
  paddingRight: "var(--ds-space-800, 64px)"
});
var errorBoundaryBoxNonDrawerStyles = css({
  margin: "var(--ds-space-600, 48px)".concat(" 0")
});
var loginButtonNonDrawerStyles = css({
  justifyContent: 'center',
  alignSelf: 'stretch'
});
var ErrorMessage = function ErrorMessage(props) {
  return jsx("p", {
    css: errorMessageStyles
  }, props.children);
};
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary() {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false
    });
    _defineProperty(_assertThisInitialized(_this), "fireOperationalEvent", function (payload) {
      if (_this.props.createAnalyticsEvent) {
        _this.props.createAnalyticsEvent(_objectSpread({
          eventType: OPERATIONAL_EVENT_TYPE,
          actionSubject: _this.props.triggerSubject || TRIGGER_SUBJECT
        }, payload)).fire(NAVIGATION_CHANNEL);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleLogin", function (_, analyticsEvent) {
      analyticsEvent.update({
        eventType: UI_EVENT_TYPE,
        actionSubjectId: 'login'
      }).fire(NAVIGATION_CHANNEL);
      if (_this.props.product !== Product.TRELLO) {
        window.location.reload();
      }
    });
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      var _this2 = this,
        _this$props$onErrorCa,
        _this$props;
      var reason = error instanceof SwitcherLoadError ? error.reason() : errorToReason(error);
      this.setState({
        hasError: true,
        reason: reason
      }, function () {
        _this2.fireOperationalEvent({
          action: ACTION_SUBJECT,
          attributes: _objectSpread(_objectSpread({}, reason), _this2.props.extraAnalyticProps)
        });
      });
      (_this$props$onErrorCa = (_this$props = this.props).onErrorCallback) === null || _this$props$onErrorCa === void 0 || _this$props$onErrorCa.call(_this$props, error);
    }
  }, {
    key: "renderErrorBody",
    value: function renderErrorBody(appearance) {
      var reason = this.state.reason;
      if (!reason) {
        return;
      }
      if (reason.name === FETCH_ERROR_NAME) {
        var isTrello = this.props.product === Product.TRELLO;
        if (reason.status === 401) {
          // Not authorised http error
          return jsx(Fragment, null, jsx(ErrorMessage, null, jsx(FormattedMessage, messages.errorTextLoggedOut)), isTrello ? jsx(StyledComponentsButton, {
            css: [loginButtonStyles, appearance !== 'drawer' && loginButtonNonDrawerStyles],
            appearance: "link",
            href: getLoginUrl(Product.TRELLO),
            onClick: this.handleLogin
          }, jsx(FormattedMessage, messages.login)) : jsx(StyledComponentsButton, {
            css: [loginButtonStyles, appearance !== 'drawer' && loginButtonNonDrawerStyles],
            onClick: this.handleLogin
          }, jsx(FormattedMessage, messages.login)));
        }
        if (reason.status === 403) {
          return jsx(ErrorMessage, null, jsx(FormattedMessage, messages.errorTextUnverified));
        }
        return jsx(ErrorMessage, null, jsx(FormattedMessage, messages.errorTextNetwork));
      }

      // Default error message
      return jsx(ErrorMessage, null, jsx(FormattedMessage, messages.errorText));
    }
  }, {
    key: "renderErrorHeading",
    value: function renderErrorHeading() {
      var reason = this.state.reason;
      if (!reason) {
        return;
      }
      if (reason.name === FETCH_ERROR_NAME && reason.status === 401) {
        return jsx(FormattedMessage, messages.errorHeadingLoggedOut);
      }
      if (reason.name === FETCH_ERROR_NAME && reason.status === 403) {
        return jsx(FormattedMessage, messages.errorHeadingUnverified);
      }
      return jsx(FormattedMessage, messages.errorHeading);
    }
  }, {
    key: "renderErrorImage",
    value: function renderErrorImage() {
      var _this$props2 = this.props,
        intl = _this$props2.intl,
        product = _this$props2.product;
      var reason = this.state.reason;
      if (product === Product.TRELLO) {
        return jsx("img", {
          css: trelloErrorImgStyles,
          src: TRELLO_ERROR_SRC,
          alt: intl.formatMessage(messages.errorImageAltText)
        });
      }
      if (reason.status === 403) {
        return jsx("img", {
          css: unverifiedUserImageStyles,
          src: UNVERIFIED_ERROR_SRC,
          alt: intl.formatMessage(messages.errorImageAltText)
        });
      }
      return jsx(RobotImage, {
        css: robotsImgStyles,
        alt: intl.formatMessage(messages.errorImageAltText)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        appearance = _this$props3.appearance,
        hideFallbackUI = _this$props3.hideFallbackUI;
      var hasError = this.state.hasError;
      if (hasError && hideFallbackUI) {
        return jsx(React.Fragment, null);
      }
      if (hasError) {
        return jsx("div", {
          css: [errorBoundaryBoxStyles, appearance === 'drawer' ? errorBoundaryBoxDrawerStyles : errorBoundaryBoxNonDrawerStyles],
          "data-testid": "error-boundary"
        }, jsx("div", {
          css: errorContentStyles
        }, this.renderErrorImage(), jsx("h3", {
          css: errorHeadingStyles
        }, this.renderErrorHeading()), this.renderErrorBody(appearance)));
      }
      return this.props.children;
    }
  }]);
  return ErrorBoundary;
}(React.Component);
var RobotImage = function RobotImage(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    imgSrc = _useState2[0],
    setImgSrc = _useState2[1];
  useEffect(function () {
    import( /* webpackChunkName: "@ak-switcher-chunk-robot-error-img" */'../../assets/robot-error').then(function (src) {
      return setImgSrc(src.default);
    });
  }, []);
  return jsx("img", _extends({}, props, {
    src: imgSrc
  }));
};
export default withAnalyticsEvents()(injectIntl(ErrorBoundary));